import { AutoLogout, EmulationBanner, Footer, MenuBar } from "@/App/components";
import { ExperienceContext } from "@/App/context";
import React, { ReactNode, useContext, useEffect, useState } from "react";

interface Props {
  children: ReactNode;
  pageTitle: string;
  label: string;
  showIconLogo: boolean;
}

export const MainLayout: React.FC<Props> = (props: Props) => {
  const { children, pageTitle } = props;
  const { experience } = useContext(ExperienceContext);
  const [isEmulation, setIsEmulation] = useState("");

  const documentPageTitle = () => {
    if (experience) {
      return pageTitle;
    } else {
      return `${site.companyName} - ${pageTitle}`;
    }
  };

  useEffect(() => {
    const body = document.body;
    body.classList.remove("authnz-root");
    document.title = documentPageTitle();

    setIsEmulation(sessionStorage.getItem("isEmulation"));
  }, []);

  return (
    <>
      <AutoLogout />
      <MenuBar />
      {isEmulation && <EmulationBanner />}

      {children}
      <Footer />
    </>
  );
};
